/** @format */

import { useMutation } from "@tanstack/react-query";
import service from "../utils/service";

const useUpdateSurvey = () =>
  useMutation({
    mutationKey: ["updateSurvey"],
    mutationFn: (surveyToUpdate) => service.updateSurvey(surveyToUpdate),
  });

export default useUpdateSurvey;
